import { getRetailer } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getRetailer";
import { useIsNotInReviewsHoldoutGroup } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingReviewsHoldoutXP";
import { useReviewsDisplayView } from "@faire/deprecated-retailer-visitor-shared/views/reviews/useReviewsDisplayView";
import { trackBrandReviewsReviewSectionScrollToActionCategoryScroll } from "@faire/web-api--source/events/brandReviews/actionCategoryScroll/reviewSectionScrollTo";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import { useCallback } from "react";

import { useProductLevelReviewCounts } from "./useProductLevelReviewCounts";

/**
 * Event tracked when the review section is scrolled into view, before the lazy chunk loads
 */
export const useTrackReviewSectionScrollIntoViewWhenVisible = ({
  brandToken,
  productToken,
  callbackWhenVisible,
}: {
  brandToken?: string;
  productToken?: string;
  callbackWhenVisible?: () => void;
}) => {
  const { totalProductReviewCount, withoutSimilarProductReviewCount } =
    useProductLevelReviewCounts(productToken, Infinity);
  const isProductReviewsEnabled = useIsNotInReviewsHoldoutGroup();
  const retailerToken = getRetailer()?.token ?? "";
  const view = useReviewsDisplayView();

  const withoutSimilarProductReviewCountString =
    withoutSimilarProductReviewCount?.toString() ?? "";
  const totalProductReviewCountString =
    totalProductReviewCount?.toString() ?? "";

  const trackReviewSectionScrollIntoView = useCallback(() => {
    trackBrandReviewsReviewSectionScrollToActionCategoryScroll(
      view,
      retailerToken,
      productToken ?? "",
      brandToken ?? "",
      "", // accidental duplicate param
      isProductReviewsEnabled ? withoutSimilarProductReviewCountString : "",
      isProductReviewsEnabled ? totalProductReviewCountString : ""
    );
    callbackWhenVisible?.();
  }, [
    callbackWhenVisible,
    view,
    retailerToken,
    productToken,
    brandToken,
    withoutSimilarProductReviewCountString,
    totalProductReviewCountString,
    isProductReviewsEnabled,
  ]);

  return useDoActionWhenVisible(trackReviewSectionScrollIntoView);
};
